module.exports = __webpack_public_path__ + "img/couples-015.c644f3aa.jpg";